'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var applyDefaultOptions = require('./utils/apply-default-options');

var toMfsPath = require('./utils/to-mfs-path');

var exporter = require('ipfs-unixfs-exporter');

var log = require('debug')('ipfs:mfs:stat');

var errCode = require('err-code');

var defaultOptions = {
  withLocal: false
};

module.exports = function (context) {
  return /*#__PURE__*/function () {
    var _mfsStat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, options) {
      var _yield$toMfsPath, type, cid, mfsPath, exportPath, file;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = applyDefaultOptions(options, defaultOptions);
              log("Fetching stats for ".concat(path));
              _context.next = 4;
              return toMfsPath(context, path);

            case 4:
              _yield$toMfsPath = _context.sent;
              type = _yield$toMfsPath.type;
              cid = _yield$toMfsPath.cid;
              mfsPath = _yield$toMfsPath.mfsPath;
              exportPath = type === 'ipfs' && cid ? cid : mfsPath;
              _context.prev = 9;
              _context.next = 12;
              return exporter(exportPath, context.ipld);

            case 12:
              file = _context.sent;
              _context.next = 20;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](9);

              if (!(_context.t0.code === 'ERR_NOT_FOUND')) {
                _context.next = 19;
                break;
              }

              throw errCode(new Error("".concat(path, " does not exist")), 'ERR_NOT_FOUND');

            case 19:
              throw _context.t0;

            case 20:
              if (statters[file.cid.codec]) {
                _context.next = 22;
                break;
              }

              throw new Error("Cannot stat codec ".concat(file.cid.codec));

            case 22:
              return _context.abrupt("return", statters[file.cid.codec](file, options));

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 15]]);
    }));

    function mfsStat(_x, _x2) {
      return _mfsStat.apply(this, arguments);
    }

    return mfsStat;
  }();
};

var statters = {
  raw: function raw(file) {
    return {
      cid: file.cid,
      size: file.node.length,
      cumulativeSize: file.node.length,
      blocks: 0,
      type: 'file',
      // for go compatibility
      local: undefined,
      sizeLocal: undefined,
      withLocality: false
    };
  },
  'dag-pb': function dagPb(file) {
    var blocks = file.node.Links.length;
    var size = file.node.size;
    var cumulativeSize = file.node.size;
    var output = {
      cid: file.cid,
      size: size,
      cumulativeSize: cumulativeSize,
      blocks: blocks,
      local: undefined,
      sizeLocal: undefined,
      withLocality: false
    };

    if (file.unixfs) {
      output.size = file.unixfs.fileSize(); // for go-ipfs compatibility

      if (file.unixfs.type === 'hamt-sharded-directory') {
        output.type = 'directory';
      } else {
        output.type = file.unixfs.type;
      }

      output.mode = file.unixfs.mode;

      if (file.unixfs.isDirectory()) {
        output.size = 0;
        output.cumulativeSize = file.node.size;
      }

      if (output.type === 'file') {
        output.blocks = file.unixfs.blockSizes.length;
      }

      if (file.unixfs.mtime) {
        output.mtime = file.unixfs.mtime;
      }
    }

    return output;
  },
  'dag-cbor': function dagCbor(file) {
    return {
      cid: file.cid,
      local: undefined,
      sizeLocal: undefined,
      withLocality: false
    };
  },
  identity: function identity(file) {
    return {
      cid: file.cid,
      size: file.node.digest.length,
      cumulativeSize: file.node.digest.length,
      blocks: 0,
      type: 'file',
      // for go compatibility
      local: undefined,
      sizeLocal: undefined,
      withLocality: false
    };
  }
};